import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { SkillsFrameworksSuggestions } from "PFApp/activities/activity_form/parts/form_sections/skills_frameworks_form_section/parts/skills_frameworks_suggestions/skills_frameworks_suggestions";
import { Accordion } from "PFComponents/accordion";
import { LoadingDots } from "PFComponents/loading_dots";
import { Tile } from "PFComponents/tile";
import type { SkillsFramework } from "PFCore/types";

import css from "./skills_frameworks_suggestions_box.module.scss";

type SkillsFrameworksSuggestionsBoxProps = {
  header: string;
  isDisabled?: boolean;
  isFetching?: boolean;
  suggestions: SkillsFramework[];
  onSuggestionClick: (skillsFramework: SkillsFramework) => void;
};

export const SkillsFrameworksSuggestionsBox = ({
  header,
  isDisabled = false,
  isFetching = false,
  onSuggestionClick,
  suggestions
}: SkillsFrameworksSuggestionsBoxProps) => {
  if (isEmpty(suggestions)) {
    return null;
  }

  return (
    <Tile
      className={classNames({ [css.isFetching]: isFetching })}
      paddingVariant="md"
      data-qa-id="SkillsFrameworks.suggestions"
    >
      <Accordion header={header} headerVariant="h5" animated={false} actions={isFetching && <LoadingDots />}>
        <SkillsFrameworksSuggestions
          showMoreButton
          isDisabled={isDisabled && !isFetching}
          suggestions={suggestions}
          onSuggestionClick={onSuggestionClick}
        />
      </Accordion>
    </Tile>
  );
};
